<template>
    <div>
        <v-toolbar>
            <v-checkbox v-model="onlyActive" label="ONLY ACTIVE LOTS" hide-details></v-checkbox>
            <v-spacer></v-spacer>
            APPLY TO MULTIPLE VINTAGES
            <v-spacer></v-spacer>
            <v-checkbox v-model="onlyThisVintage" label="ONLY THIS VINTAGE" hide-details></v-checkbox>
        </v-toolbar>
        <v-data-table
          :headers='headers'
          :items='lotsTable'
          hide-actions
          >
          <template slot="items" slot-scope="props">
                <tr>
                  <td width="50px">
                    <v-checkbox :disabled="props.item.lotNumber == primaryLot"
                        v-model="props.item.isSelected"
                        @change="valueChanged(props.item, props.index)"
                        hide-details
                    ></v-checkbox>
                  </td>
                  <td width="75px">{{ props.item.lotNumber }}</td>
                  <td width="150px">{{ props.item.description }}</td>
                  <td width="75px">
                    <v-text-field v-if="props.item.isSelected"
                                  v-model="props.item.so2Add"
                                  @change="valueChanged(props.item, props.index)"
                                  hide-details></v-text-field>
                  </td>
                  <td width="200px">
                      <v-autocomplete v-if="props.item.isSelected"
                        v-model ='props.item.toppingLot'
                        :items='activeLots'
                        item-text='fullDescription'
                        item-value='lotNumber'
                        @change="valueChanged(props.item, props.index)"
                        hide-details
                    ></v-autocomplete>
                  </td>
                  <td width="200px">
                    <v-textarea
                       v-model="props.item.otherDesc"
                       hide-details
                       @change="valueChanged(props.item, props.index)"
                       row-height="24"
                       rows="1"
                       clearable
                    >
                    </v-textarea>
                  </td>
                  <td width="100px">
                    <span v-if="props.item.isSelected" @click="rowClicked(props.item)">
                      {{ props.item.woId }}
                    </span>
                  </td>
                  <td width="100px">
                    <v-checkbox color="primary"
                       hide-details
                       v-if="props.item.isSelected"
                       v-model='props.item.isComplete'
                       @change="valueChanged(props.item, props.index)"
                       :readonly="!isStaff()">
                    </v-checkbox>
                  </td>
                </tr>
          </template>
        </v-data-table>
    </div>
</template>

<script>
import myMixins from '../mixins/myMixins'
export default {
  props: ['selectedLots', 'date', 'primaryLot'], // primaryLot is the lot of the parent workorder. we need to know this to prevent unselecting that lot.
  mixins: [myMixins],
  data () {
    return {
      onlyActive: true,
      onlyThisVintage: true,
      selected: this.selectedLots,
      lotsTable: [
        {
          isSelected: false
        }
      ],
      dataByKey: {},
      headers: [
        { text: 'Select', value: 'select', sortable: false },
        { text: 'Lot #', value: 'lotNumber', sortable: true },
        { text: 'Lot Name', value: 'description', sortable: true },
        { text: 'SO2 (PPM)', value: 'so2Add', sortable: true },
        { text: 'Top With Lot', value: 'toppingLot', sortable: true },
        { text: 'Comments', value: 'comments', sortable: true },
        { text: 'WO ID', value: 'woId', sortable: false },
        { text: 'Completed', value: 'status', sortable: false }
      ]
    }
  },
  watch: {
    selectedLots: function () {
      let $this = this
      this.selected = this.selectedLots
      this.dataByKey = {}
      this.selected.forEach(function (lot) {
        $this.dataByKey[lot.lotNumber] = lot
      })
      this.updateLotsTable()
    },
    onlyActive: function () {
      this.updateLotsTable()
    },
    onlyThisVintage: function () {
      this.updateLotsTable()
    }
  },
  created () {
    let $this = this
    this.selected = this.selectedLots
    this.selected.forEach(function (lot) {
      $this.dataByKey[lot.lotNumber] = lot
    })
    this.updateLotsTable()
  },
  methods: {
    rowClicked (item) {
      console.log('row clicked')
      this.$emit('workOrderTapped', item)
    },
    // this is called anytime the user picks a different filter from all lots, to just active, to just vintage, and on creation
    updateLotsTable () {
      let $this = this
      this.lotsTable = JSON.parse(JSON.stringify(this.$store.state.allLotsForClient))
      this.lotsTable = this.lotsTable.filter(function (lot) {
        if ($this.onlyActive && !lot.isActive) return false
        if ($this.onlyThisVintage && !(lot.year === $this.vintage)) return false
        return true
      })

      this.lotsTable.forEach(function (lot, index) {
        if ($this.dataByKey[lot.lotNumber]) {
          $this.lotsTable[index].isSelected = true

          // just remember that if you add anything in this list of things to be saved you need to  also modify the backend endpoint
          $this.lotsTable[index].toppingLot = $this.dataByKey[lot.lotNumber].toppingLot
          $this.lotsTable[index].otherDesc = $this.dataByKey[lot.lotNumber].otherDesc
          $this.lotsTable[index].taskId = $this.dataByKey[lot.lotNumber].taskId
          lot.toppingLot = $this.dataByKey[lot.lotNumber].toppingLot
          lot.otherDesc = $this.dataByKey[lot.lotNumber].otherDesc
          lot.isComplete = $this.dataByKey[lot.lotNumber].isComplete
          lot.woId = $this.dataByKey[lot.lotNumber].woId
          lot.so2Add = $this.dataByKey[lot.lotNumber].so2Add
        } else {
          $this.lotsTable[index].isSelected = false
        }
      })
      this.$emit('lotsUpdated', this.dataByKey)
    },
    isCompleteClicked (lotNumber) {
      this.dataByKey[lotNumber].isComplete = !this.dataByKey[lotNumber].isComplete
    },
    valueChanged (value, index) {
      this.dataByKey[this.lotsTable[index].lotNumber] = value
      this.$emit('lotsUpdated', this.dataByKey)
    },
    isComplete (lotNumber) {
      if (this.dataByKey[lotNumber]) {
        return this.dataByKey[lotNumber].isComplete
      } else {
        return false
      }
    },
    otherDesc (lotNumber) {
      if (this.dataByKey[lotNumber]) {
        return this.dataByKey[lotNumber].otherDesc
      } else {
        return ''
      }
    },
    toppingLot (lotNumber) {
      if (this.dataByKey[lotNumber]) {
        return this.dataByKey[lotNumber].toppingLot
      } else {
        return ''
      }
    },
    so2Add (lotNumber) {
      if (this.dataByKey[lotNumber]) {
        return this.dataByKey[lotNumber].so2Add
      } else {
        return ''
      }
    },
    woId (lotNumber) {
      if (this.dataByKey[lotNumber]) {
        return this.dataByKey[lotNumber].woId
      } else {
        return ''
      }
    },
    completed (lotNumber) {
      if (this.dataByKey[lotNumber]) {
        return this.dataByKey[lotNumber].status
      } else {
        return ''
      }
    }
  },
  computed: {
    vintage () {
      return this.$store.state.vintage
    },
    lots () {
      return this.$store.state.lotsForVintage
    },
    activeLots () {
      return this.$store.state.allActiveLotsForClient
    }
  }
}
</script>

<style scoped>
td {
  border: 1px solid gray;
}
</style>
